<template>
  <div class="home">
    <!-- <a-row :gutter="16">
      <a-button style="float: right; margin-top: 1em" @click="currentStep++"
        >Pomiń krok</a-button
      >
      <a-button style="float: right; margin-top: 1em" @click="currentStep--"
        >Poprzedni krok</a-button
      >
    </a-row> -->
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card>
          <div :style="{
            marginTop: '16px',
            paddingLeft: '16px',
            paddingRight: '16px',
          }">
            <a-steps :current="currentStep - 2" style="overflow-y: auto; padding-top: 8px">
              <a-popover slot="progressDot" slot-scope="{ index, prefixCls }">
                <template slot="content">
                  <span>Krok {{ index + 1 }}</span>
                </template>
                <span :class="`${prefixCls}-icon-dot`"/>
              </a-popover>
              <a-step subTitle="Podstawowe informacje" title="Dane osobowe"/>
              <a-step subTitle="Informacje o lokalizacjach" title="Dane adresowe"/>
              <a-step subTitle="Informacje o uczelni i akademiku" title="Dane uczelniane"/>
              <a-step subTitle="Informacje o urządzeniu" title="Dane urządzenia"/>
              <a-step subTitle="Zasady korzystania z sieci" title="Regulamin"/>
              <a-step subTitle="Ważne informacje, przesłanie wniosku" title="Podsumowanie"/>
            </a-steps>
          </div>
          <a-card :style="{ width: 'auto', marginTop: '24px' }">
            <Step2 v-if="currentStep === 2" @nextStep="nextStep" @prevStep="prevStep"></Step2>
            <Step3 v-if="currentStep === 3" @nextStep="nextStep" @prevStep="prevStep"></Step3>
            <Step4 v-if="currentStep === 4" @nextStep="nextStep" @prevStep="prevStep"></Step4>
            <Step5 v-if="currentStep === 5" @nextStep="nextStep" @prevStep="prevStep"></Step5>
            <Step6 v-if="currentStep === 6" @nextStep="nextStep" @prevStep="prevStep"></Step6>
            <Step7 v-if="currentStep === 7" @nextStep="nextStep" @prevStep="prevStep"></Step7>
          </a-card>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Step2 from "@/components/steps/Step2.vue";
import Step3 from "@/components/steps/Step3.vue";
import Step4 from "@/components/steps/Step4.vue";
import Step5 from "@/components/steps/Step5.vue";
import Step6 from "@/components/steps/Step6.vue";
import Step7 from "@/components/steps/Step7.vue";

export default {
  name: "Profile",
  components: {
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7
  },
  // ===========================================================
  data() {
    return {
      currentStep: 2,
      steps: {
        verification: false,
        userData: false,
        additionalData: false,
        terms: false,
      },
    };
  },
  // ===========================================================
  beforeMount() {
    window.addEventListener("beforeunload", this.preventRefresh);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventRefresh);
    });
  },
  // ===========================================================
  mounted() {
    this.$emit("loadedView");
  },
  // ===========================================================
  beforeRouteLeave(to, from, next) {
    // console.log("Go to:", to);
    if (this.currentStep < 7) {
      this.$confirm({
        title: "Czy aby na pewno chcesz opuścić formularz?",
        content: "Dane nie zostały zapisane i zostaną utracone.",
        okText: "Opuszczam",
        okType: "danger",
        cancelText: "Anuluj",
        onOk() {
          next();
        },
        onCancel() {
          next(false);
        },
      });
    } else {
      next();
    }
  },
  // ===========================================================
  methods: {
    preventRefresh(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    nextStep: function () {
      this.currentStep += 1;
      console.log("Go to step #" + this.currentStep);
    },
    prevStep: function () {
      this.currentStep -= 1;
      console.log("Go back to step #" + this.currentStep);
    },
    // ---------------------------------------------------------
  },
};
</script>